var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
import { struct, types as t } from 'utilium';
let SLComponentRecord = (() => {
    var _a, _b;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _flags_decorators;
    let _flags_initializers = [];
    let _flags_extraInitializers = [];
    let _componentLength_decorators;
    let _componentLength_initializers = [];
    let _componentLength_extraInitializers = [];
    var SLComponentRecord = class {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _flags_decorators = [(_a = t).uint8.bind(_a)];
            _componentLength_decorators = [(_b = t).uint8.bind(_b)];
            __esDecorate(null, null, _flags_decorators, { kind: "field", name: "flags", static: false, private: false, access: { has: obj => "flags" in obj, get: obj => obj.flags, set: (obj, value) => { obj.flags = value; } }, metadata: _metadata }, _flags_initializers, _flags_extraInitializers);
            __esDecorate(null, null, _componentLength_decorators, { kind: "field", name: "componentLength", static: false, private: false, access: { has: obj => "componentLength" in obj, get: obj => obj.componentLength, set: (obj, value) => { obj.componentLength = value; } }, metadata: _metadata }, _componentLength_initializers, _componentLength_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            SLComponentRecord = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        data;
        constructor(data) {
            __runInitializers(this, _componentLength_extraInitializers);
            this.data = data;
        }
        flags = __runInitializers(this, _flags_initializers, void 0);
        componentLength = (__runInitializers(this, _flags_extraInitializers), __runInitializers(this, _componentLength_initializers, void 0));
        get length() {
            return 2 + this.componentLength;
        }
        content(getString) {
            return getString(this.data.slice(2, 2 + this.componentLength));
        }
    };
    return SLComponentRecord = _classThis;
})();
export { SLComponentRecord };
//# sourceMappingURL=SLComponentRecord.js.map